<template>
<div class="hg-detection-tag">
	<el-tag
  :key="tag"
  v-for="tag in dynamicTags"
  :closable="!disabled"
  :disable-transitions="false"
  @close="handleClose(tag)">
  {{tag}}
</el-tag>
<el-input
  class="input-new-tag"
  v-if="inputVisible"
  v-model="inputValue"
  ref="saveTagInput"
  size="small"
  @keyup.enter.native="handleInputConfirm"
  @blur="handleInputConfirm"
>
</el-input>
<el-button :disabled="disabled" v-else class="button-new-tag" size="small" @click="showInput">+ 新标签</el-button>
</div>
</template>
<script>
export default {
  name: 'detectionTag',
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  watch: {
    dynamicTags: {
      handler: function (val, old) {
        this.$emit('input', val)
      }
    },
    value: {
      handler: function (val, old) {
        if (val) {
          this.dynamicTags = val
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let _this = this
      let inputValue = _this.inputValue
      if (inputValue) {
        _this.dynamicTags.push(inputValue)
      }
      _this.inputVisible = false
      _this.inputValue = ''
    }
  },
  created () {
    if (this.value.length) {
      console.log('this.value', this.value)
      this.dynamicTags = this.value
    }
  }
}
</script>
<style lang="less">
.hg-detection-tag{
  .el-tag {
    margin-right: 10px;
  }
  .input-new-tag.el-input{
    max-width: 80px;
  }
}

</style>
